import { Routes } from '@angular/router';
import { RoleAccessGuard } from './guards/role-access.guard';
import { AppVersionsComponent } from './pages/app-versions/app-versions.component';
import { CreateAppComponent } from './pages/create-app/create-app.component';
import { CustomDomainRequestsComponent } from './pages/custom-domain-requests/custom-domain-requests.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { EditAppComponent } from './pages/edit-app/edit-app.component';
import { LoginComponent } from './pages/login.component';
import { UserManagementComponent } from './pages/user-management.component';

export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    {
        path: 'generate-app',
        component: CreateAppComponent,
        canActivate: [RoleAccessGuard],
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [RoleAccessGuard],
    },
    {
        path: 'user-management',
        component: UserManagementComponent,
        canActivate: [RoleAccessGuard],
    },
    {
        path: 'app',
        children: [
            {
                path: ':id/edit',
                component: EditAppComponent,
            },
        ],
        canActivate: [RoleAccessGuard],
    },
    {
        path: 'app-versions',
        component: AppVersionsComponent,
        canActivate: [RoleAccessGuard],
    },
    {
        path: 'custom-domain-requests',
        component: CustomDomainRequestsComponent,
        canActivate: [RoleAccessGuard],
    },
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: '**', redirectTo: '/login' },
];
